import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

const ReactTooltipWrapper = styled.div`
  .type-dark {
    background-color: rgba(57, 64, 74, 0.9) !important;
    &.place-bottom {
      &:after {
        border-bottom-color: rgba(57, 64, 74, 0.9) !important;
      }
    }
    &.place-top {
      &:after {
        border-top-color: rgba(57, 64, 74, 0.9) !important;
      }
    }
  }

  .tooltipClass {
    max-width: 200px;
    font-family: OpenSans;
    font-size: 12px;
    text-align: center;
    direction: ltr;
  }
`;

const Tooltip = () => (
  <ReactTooltipWrapper>
    <ReactTooltip
      className="tooltipClass"
      place="top"
      effect="solid"
      dir="ltr"
    />
  </ReactTooltipWrapper>
);

export default Tooltip;
